export default class PaymentError extends Error {}
